import React from "react";

import { mdiImageFilterHdr } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

import {
  PictureRatio,
  PictureRatioContainer,
  PictureRatioLabel,
  PictureRatioWrapper,
} from "./CarouselPictureRatio";
import COLORS from "../../../constants/colors";

import type { JSX } from "react";

import type { HorizontalImageFormat } from "../../../constants/ratio";

interface CarouselDoubleRowProps {
  onClick: (row: "double") => void;
  isSelected: boolean;
  ratio?: HorizontalImageFormat;
}

function CarouselDoubleRow({
  onClick,
  isSelected,
  ratio,
}: CarouselDoubleRowProps): JSX.Element {
  const { t } = useTranslation("editor-platform");

  return (
    <PictureRatioWrapper
      className="gap-[6px]"
      onClick={(): void => onClick("double")}
    >
      <PictureRatioContainer isSelected={isSelected}>
        {Array.from({ length: 2 }, () => (
          <div key={uuidv4()} className="flex flex-col gap-[6px]">
            {Array.from({ length: 2 }, () => (
              <PictureRatio
                key={uuidv4()}
                className="h-[47px]"
                isSelected={isSelected}
                ratio={ratio}
              >
                <Icon
                  path={mdiImageFilterHdr}
                  size="26px"
                  color={
                    isSelected ? COLORS.primary.DEFAULT : COLORS.grey.DEFAULT
                  }
                />
              </PictureRatio>
            ))}
          </div>
        ))}
      </PictureRatioContainer>
      <PictureRatioLabel isSelected={isSelected}>
        {t("carouselFormat.double")}
      </PictureRatioLabel>
    </PictureRatioWrapper>
  );
}

export default CarouselDoubleRow;
